/* Persists the dismissed-notification ids.
 *
 * There is no backend delete for a notification, so dismissal is kept per browser. The write runs
 * as a listener rather than inside the reducer to keep that reducer pure — see listenerMiddleware.
 *
 * Importing this module registers the listener; store.ts does that once at startup.
 */
import { eLocalStorageKeys } from 'src/constants/generic-constants';
import { startAppListening } from 'src/store/listenerMiddleware';
import { save } from 'src/utils/local-storage';
import { notificationDismissed } from './notificationsSlice';

startAppListening({
  actionCreator: notificationDismissed,
  effect: (_action, listenerApi) => {
    // Reads the post-update state, so the stored list always matches the store and the dedupe
    // rule does not have to be repeated here.
    const { dismissedIds } = listenerApi.getState().notificationsStore;
    save(eLocalStorageKeys.DismissedNotifications, [...dismissedIds]);
  }
});
